var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessHandshakeDealContractBusinessMoneyPaymentAgreement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.782959 4.40686L3.91784 6.09397L6.71606 5.60949C7.66066 5.44595 8.62869 5.71635 9.35181 6.34573",
    stroke: "#215250",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1174 13.2607L11.6852 16.4084C10.7109 17.1004 9.40889 17.1129 8.42149 16.4397L0.782959 11.2327",
    stroke: "#215250",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1461 11.1993L16.0099 13.3423L11.144 9.41326L9.35412 10.7159C8.62633 11.2456 7.60963 11.1029 7.0558 10.3933C6.50325 9.68536 6.60985 8.6671 7.29705 8.0889L9.16073 6.52083C10.054 5.76927 11.2151 5.4146 12.3759 5.5388L15.2805 5.84957L19.1461 3.76013",
    stroke: "#EA7F4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1448 9.42372C12.3156 10.4669 13.9761 9.9347 14.5935 9.08313",
    stroke: "#EA7F4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessHandshakeDealContractBusinessMoneyPaymentAgreement);
export default __webpack_public_path__ + "static/media/business-handshake--deal-contract-business-money-payment-agreement.53b3038615c3c078eaa2b5de81230fd9.svg";
export { ForwardRef as ReactComponent };